<template>
  <div class="row">
    <div class="col-md-12">
      <div
        class="alert alert-warning"
      >3.1. Оборудование помещений организации социальной сферы и прилегающей к ней территории с учетом доступности для инвалидов</div>
      <div
        class="alert alert-info"
      >3.1.1. Наличие в помещениях организации социальной сферы и на прилегающей к ней территории:</div>
      <div class="well">
        <strong>1) оборудованных входных групп пандусами (подъемными платформами);</strong>
        <div class="form-group clearfix">
          <input name="pole_0" id="pole_0_0" type="radio" value="0" v-model="answers[0]" />
          <label class="form-control btn btn-info" for="pole_0_0">Да</label>
          <input name="pole_0" id="pole_0_1" type="radio" value="1" v-model="answers[0]" />
          <label class="form-control btn btn-info" for="pole_0_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>2) выделенных стоянок для автотранспортных средств инвалидов;</strong>
        <div class="form-group clearfix">
          <input name="pole_1" id="pole_1_0" type="radio" value="0" v-model="answers[1]" />
          <label class="form-control btn btn-info" for="pole_1_0">Да</label>
          <input name="pole_1" id="pole_1_1" type="radio" value="1" v-model="answers[1]" />
          <label class="form-control btn btn-info" for="pole_1_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>3) адаптированных лифтов, поручней, расширенных дверных проемов;</strong>
        <div class="form-group clearfix">
          <input name="pole_2" id="pole_2_0" type="radio" value="0" v-model="answers[2]" />
          <label class="form-control btn btn-info" for="pole_2_0">Да</label>
          <input name="pole_2" id="pole_2_1" type="radio" value="1" v-model="answers[2]" />
          <label class="form-control btn btn-info" for="pole_2_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>4) сменных кресел-колясок;</strong>
        <div class="form-group clearfix">
          <input name="pole_3" id="pole_3_0" type="radio" value="0" v-model="answers[3]" />
          <label class="form-control btn btn-info" for="pole_3_0">Да</label>
          <input name="pole_3" id="pole_3_1" type="radio" value="1" v-model="answers[3]" />
          <label class="form-control btn btn-info" for="pole_3_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>5) специально оборудованных санитарно-гигиенических помещений в организации социальной сферы</strong>
        <div class="form-group clearfix">
          <input name="pole_4" id="pole_4_0" type="radio" value="0" v-model="answers[4]" />
          <label class="form-control btn btn-info" for="pole_4_0">Да</label>
          <input name="pole_4" id="pole_4_1" type="radio" value="1" v-model="answers[4]" />
          <label class="form-control btn btn-info" for="pole_4_1">Нет</label>
        </div>
      </div>
      <div
        class="alert alert-warning"
      >3.2. Обеспечение в организации социальной сферы условий доступности, позволяющих инвалидам получать услуги наравне с другими</div>
      <div
        class="alert alert-info"
      >3.2.1. Наличие в организации социальной сферы условий доступности, позволяющих инвалидам получать услуги наравне с другими:</div>

      <div class="well">
        <strong>1) дублирование для инвалидов по слуху и зрению звуковой и зрительной информации;</strong>
        <div class="form-group clearfix">
          <input name="pole_5" id="pole_5_0" type="radio" value="0" v-model="answers[5]" />
          <label class="form-control btn btn-info" for="pole_5_0">Да</label>
          <input name="pole_5" id="pole_5_1" type="radio" value="1" v-model="answers[5]" />
          <label class="form-control btn btn-info" for="pole_5_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>2) дублирование надписей, знаков и иной текстовой и графической информации знаками, выполненными рельефно-точечным шрифтом Брайля;</strong>
        <div class="form-group clearfix">
          <input name="pole_6" id="pole_6_0" type="radio" value="0" v-model="answers[6]" />
          <label class="form-control btn btn-info" for="pole_6_0">Да</label>
          <input name="pole_6" id="pole_6_1" type="radio" value="1" v-model="answers[6]" />
          <label class="form-control btn btn-info" for="pole_6_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>3) возможность предоставления инвалидам по слуху (слуху и зрению) услуг сурдопереводчика (тифлосурдопереводчика);</strong>
        <div class="form-group clearfix">
          <input name="pole_7" id="pole_7_0" type="radio" value="0" v-model="answers[7]" />
          <label class="form-control btn btn-info" for="pole_7_0">Да</label>
          <input name="pole_7" id="pole_7_1" type="radio" value="1" v-model="answers[7]" />
          <label class="form-control btn btn-info" for="pole_7_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>4) наличие альтернативной версии официального сайта организации социальной сферы в сети «Интернет» для инвалидов по зрению;</strong>
        <div class="form-group clearfix">
          <input name="pole_8" id="pole_8_0" type="radio" value="0" v-model="answers[8]" />
          <label class="form-control btn btn-info" for="pole_8_0">Да</label>
          <input name="pole_8" id="pole_8_1" type="radio" value="1" v-model="answers[8]" />
          <label class="form-control btn btn-info" for="pole_8_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>5) помощь, оказываемая работниками организации социальной сферы, прошедшими необходимое обучение (инструктирование) по сопровождению инвалидов в помещениях организации социальной сферы и на прилегающей территории;</strong>
        <div class="form-group clearfix">
          <input name="pole_9" id="pole_9_0" type="radio" value="0" v-model="answers[9]" />
          <label class="form-control btn btn-info" for="pole_9_0">Да</label>
          <input name="pole_9" id="pole_9_1" type="radio" value="1" v-model="answers[9]" />
          <label class="form-control btn btn-info" for="pole_9_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>6) наличие возможности предоставления услуги в дистанционном режиме или на дому</strong>
        <div class="form-group clearfix">
          <input name="pole_10" id="pole_10_0" type="radio" value="0" v-model="answers[10]" />
          <label class="form-control btn btn-info" for="pole_10_0">Да</label>
          <input name="pole_10" id="pole_10_1" type="radio" value="1" v-model="answers[10]" />
          <label class="form-control btn btn-info" for="pole_10_1">Нет</label>
        </div>
      </div>

      <div
        class="alert alert-warning"
      >2.1. Обеспечение в организации социальной сферы комфортных условий для предоставления услуг</div>
      <div
        class="alert alert-info"
      >2.1.1. Наличие комфортных условий для предоставления услуг, например:</div>

      <div class="well">
        <strong>1) наличие комфортной зоны отдыха (ожидания) оборудованной соответствующей мебелью;</strong>
        <div class="form-group clearfix">
          <input name="pole_11" id="pole_11_0" type="radio" value="0" v-model="answers[11]" />
          <label class="form-control btn btn-info" for="pole_11_0">Да</label>
          <input name="pole_11" id="pole_11_1" type="radio" value="1" v-model="answers[11]" />
          <label class="form-control btn btn-info" for="pole_11_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>2) наличие и понятность навигации внутри организации социальной сферы;</strong>
        <div class="form-group clearfix">
          <input name="pole_12" id="pole_12_0" type="radio" value="0" v-model="answers[12]" />
          <label class="form-control btn btn-info" for="pole_12_0">Да</label>
          <input name="pole_12" id="pole_12_1" type="radio" value="1" v-model="answers[12]" />
          <label class="form-control btn btn-info" for="pole_12_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>3) наличие и доступность питьевой воды;</strong>
        <div class="form-group clearfix">
          <input name="pole_13" id="pole_13_0" type="radio" value="0" v-model="answers[13]" />
          <label class="form-control btn btn-info" for="pole_13_0">Да</label>
          <input name="pole_13" id="pole_13_1" type="radio" value="1" v-model="answers[13]" />
          <label class="form-control btn btn-info" for="pole_13_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>4) наличие и доступность санитарно-гигиенических помещений;</strong>
        <div class="form-group clearfix">
          <input name="pole_14" id="pole_14_0" type="radio" value="0" v-model="answers[14]" />
          <label class="form-control btn btn-info" for="pole_14_0">Да</label>
          <input name="pole_14" id="pole_14_1" type="radio" value="1" v-model="answers[14]" />
          <label class="form-control btn btn-info" for="pole_14_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>5) санитарное состояние помещений организации социальной сферы;</strong>
        <div class="form-group clearfix">
          <input name="pole_15" id="pole_15_0" type="radio" value="0" v-model="answers[15]" />
          <label class="form-control btn btn-info" for="pole_15_0">Да</label>
          <input name="pole_15" id="pole_15_1" type="radio" value="1" v-model="answers[15]" />
          <label class="form-control btn btn-info" for="pole_15_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>6) транспортная доступность (возможность доехать до организации социальной сферы на общественном транспорте, наличие парковки);</strong>
        <div class="form-group clearfix">
          <input name="pole_16" id="pole_16_0" type="radio" value="0" v-model="answers[16]" />
          <label class="form-control btn btn-info" for="pole_16_0">Да</label>
          <input name="pole_16" id="pole_16_1" type="radio" value="1" v-model="answers[16]" />
          <label class="form-control btn btn-info" for="pole_16_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>7) доступность записи на получение услуги (по телефону, на официальном сайте организации социальной сферы в сети «Интернет», посредством Единого портала государственных и муниципальных услуг, при личном посещении в регистратуре или у специалиста организации социальной сферы);</strong>
        <div class="form-group clearfix">
          <input name="pole_17" id="pole_17_0" type="radio" value="0" v-model="answers[17]" />
          <label class="form-control btn btn-info" for="pole_17_0">Да</label>
          <input name="pole_17" id="pole_17_1" type="radio" value="1" v-model="answers[17]" />
          <label class="form-control btn btn-info" for="pole_17_1">Нет</label>
        </div>
      </div>

      <div class="well">
        <strong>8) иные параметры комфортных условий, установленные ведомственным нормативным актом уполномоченного федерального органа исполнительной власти</strong>
        <div class="form-group clearfix">
          <input name="pole_18" id="pole_18_0" type="radio" value="0" v-model="answers[18]" />
          <label class="form-control btn btn-info" for="pole_18_0">Да</label>
          <input name="pole_18" id="pole_18_1" type="radio" value="1" v-model="answers[18]" />
          <label class="form-control btn btn-info" for="pole_18_1">Нет</label>
        </div>
      </div>
      <div v-if="done" class='alert alert-success'>Спасибо за ответ. Все сохранено</div>
      <button class='btn btn-success d-md-block' @click='send'>Сохранить</button>
     

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import nprogress from 'nprogress'

export default {
  created: function(){
      this.getdata();
    },
  methods:{
    getdata: function(){
      nprogress.start();
      axios({
        withCredentials: true,
        url: "http://eduqa.egechita.ru/back/getanketaresultmoyo/"+this.$route.params.id
      }).then(Response => {
        if(Response.data.status == 1){
          this.answers = Response.data.data;
          nprogress.done();
        }
      });
    },
    send: function(){
      var max = 18;
      for(var i = 0; i <= max; i++){
        if(this.answers[i] == undefined || this.answers[i] == null){
          var elem = document.querySelectorAll('label[for="pole_'+i+'_0"]');
          for(var j = 0; j < elem.length; j++) {
              elem[j].style.backgroundColor = 'red';
          }
          var elem = document.querySelectorAll('label[for="pole_'+i+'_1"]');
          for(var j = 0; j < elem.length; j++) {
              elem[j].style.backgroundColor = 'red';
          }
          return;
        }
      }
      nprogress.start();
      axios({
        method: "POST",
        url: "http://eduqa.egechita.ru/back/anketasave/"+this.$route.params.id,
        data: this.answers,
        withCredentials: true,
      }).then(Response => {
        nprogress.done();
        this.done = true;

      });
    }
  },
    data() {
      return {
        answers: [],
        done: false
      }
    }
};
</script>

<style scoped>
input[type="radio"]:checked + label.btn {
  background-color: rgb(24, 218, 201);
}
input[type="radio"] {
  display: none;
}
</style>